var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.calcInputType)?_c('base-input',_vm._g(_vm._b({attrs:{"dense":"","outlined":"","hide-details":"auto","label":_vm.label,"value":_vm.value,"type":_vm.calcInputType,"options":_vm.valOptions,"clearable":""},on:{"input":function($event){return _vm.$emit('input', $event)}}},'base-input',_vm.$attrs,false),_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }